import { GroupChannelType } from '@/interfaces/chat'
import { environment } from '@/shared/consts/environment'
import axios from 'axios'
import './axiosAuthMiddleware'
import { errorMiddleware } from './errorMiddleware'

const apiUrl = `${environment.apiUrl}/api/v1/chat`

export const changeChannelCustomType = async (
  channelUrl: string,
  customType: GroupChannelType
) => {
  try {
    const res = await axios.post(`${apiUrl}/channel/custom-type`, {
      channelUrl: channelUrl,
      customType: customType,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const createChannel = async (invitedUserIds: string[]) => {
  try {
    const res = await axios.post(`${apiUrl}/channel`, {
      invitedUserIds,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const deleteDmChannel = async (channelUrl: string) => {
  try {
    const res = await axios.post(`${apiUrl}/channel/delete`, {
      channel_url: channelUrl,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const syncUser = async () => {
  try {
    const res = await axios.post(`${apiUrl}/user/sync`)
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const sendUnreadMessageNotification = async (
  receiverId: string,
  channelUrl: string
) => {
  try {
    const res = await axios.post(`${apiUrl}/notification/unread-message`, {
      receiverId,
      channelUrl,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}

export const sentMessage = async (senderId: string, receiverId: string) => {
  try {
    const res = await axios.post(`${apiUrl}/notification/sent-message`, {
      senderId,
      receiverId,
    })
    return res.data
  } catch (error) {
    return errorMiddleware(error)
  }
}
